import { useState } from 'preact/hooks';

const buildQs = (params) => {
  if (!params || (params && Object.keys(params).length === 0 && params.constructor === Object)) {
    return '';
  }

  return `?${Object.keys(params)
    .map((key) => key + '=' + params[key])
    .join('&')}`;
};

interface FetchReturn<T> {
  response: T;
  error: any;
  loading: boolean;
  fetchData: (data?: {}, params?: {}) => Promise<{ data: any; error: any }>;
  called: boolean;
}
export function useFetch<T extends Record<string, any>>(url: string, options, defaultLoading = false): FetchReturn<T> {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(defaultLoading);
  const [called, setCalled] = useState(defaultLoading);

  const fetchData = async (data = {}, params = {}) => {
    try {
      setLoading(true);
      const payload = {
        headers: { 'content-type': 'application/json' },
        ...options,
        ...data,
      };
      setCalled(true);
      const res = await fetch(`${url}${buildQs(params)}`, payload);
      const json = await res.json();
      setResponse(json);
      setTimeout(() => {
        setLoading(false);
      }, 500);
      return { data: json, error: undefined };
    } catch (error) {
      setCalled(true);
      setResponse(null);
      setLoading(false);
      setError(error);
      console.warn(error);
      return { error, data: {} };
    }
  };

  return { response, error, loading, fetchData, called };
}
